import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-cascade",
  "use": "icon-nav-cascade-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-nav-cascade\"><circle cx=\"12\" cy=\"5\" r=\"2.5\" /><circle cx=\"5\" cy=\"19\" r=\"2.5\" /><circle cx=\"19\" cy=\"19\" r=\"2.5\" /><path d=\"M12 7.5v4.5\" /><path d=\"M12 12l-5.5 4.5\" /><path d=\"M12 12l5.5 4.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/nav/nav-cascade.svg
// module id = +BlO
// module chunks = 24